import React, { useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import { Col, Row, Space } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { DataList, ListReq } from 'Store/agent/types'
import { selectList, selectListEvent } from 'Store/agent/selector'
import { formatAgentype, formatDateTime, getAgentStatus, isFilter } from 'helpers/format'
import { StatusTag } from 'Components/utilities'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { Pagination } from 'Components/Pagination'
import { SearchInput, SelectItem } from 'Components/form'
import LinkText from 'Components/text/LinkText'
import { Theme } from 'Components/common'
import { cloneDeep } from 'lodash'
import { CheckOutlined, EditOutlined } from '@ant-design/icons'
import { AgentStatus, menuAgentStatus } from 'helpers/constanst'
import AgentDetail from './detail'
import { getAgentListAPI } from 'Store/agent/api'
import { selectLoginData } from 'Store/user/selector'
import { MyTheme } from 'Components/common/Theme'

type Props = {} & RouteComponentProps & ReduxProps

const Agents: React.FunctionComponent<Props> = props => {
  const { listEvent, dataList, loginData } = props
  const dispatch = useDispatch()
  const [resetFilter, setResetFilter] = useState(false)
  const [selected, setSelected] = useState({} as DataList)
  const [pageMode, setPageMode] = useState('approve' as 'edit' | 'approve')
  const [drawer, setDrawer] = useState(false)

  const initFilter = {
    start_date: '',
    end_date: '',
    merchant_id: 0,
    keyword: '',
    status: '',
  }
  const [filter, setFilter] = useState(cloneDeep(initFilter))
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = dataList.meta
  const datas = dataList.data

  const onGetDataList = (): void => {
    const req: ListReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      status: filter.status,
      name: filter.keyword,
    }
    dispatch(getAgentListAPI(req, loginData?.access_token || ''))
  }

  useEffect(() => {
    if (loginData?.access_token) {
      onGetDataList()
    }
  }, [pagination])

  useEffect(() => {
    if (resetFilter) {
      onGetDataList()
      setResetFilter(false)
    }
  }, [resetFilter])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onClickEdit = (item: DataList) => {
    setSelected(item)
    onOpenDrawer()
    setPageMode('edit')
  }

  const onClickApprove = (item: DataList) => {
    setSelected(item)
    onOpenDrawer()
    setPageMode('approve')
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetDataList()
  }

  const onResetFilter = () => {
    setFilter(cloneDeep({ ...initFilter }))
    setResetFilter(true)
  }

  const renderStatus = (value: any) => {
    const result = getAgentStatus(value)
    return <StatusTag color={result.color} text={result.text} />
  }

  const renderAgentName = (value: any, record: DataList) => {
    return <Link onClick={() => onClickApprove(record)}>{value}</Link>
  }

  const renderActionButton = (text: string, record: DataList) => {
    const isPendding = record?.status === AgentStatus.PENDING
    if (!isPendding) return
    return (
      <Row justify="center" gutter={[8, 8]}>
        <Col>
          <ActionButton
            text=""
            icon={<CheckOutlined />}
            label="อนุมัติ"
            action="default"
            onClick={() => onClickApprove(record)}
            size="small"
          />
        </Col>
        <Col>
          <ActionButton
            text=""
            icon={<EditOutlined />}
            label="แก้ไขข้อมูล"
            action="edit"
            onClick={() => onClickEdit(record)}
            size="small"
          />
        </Col>
      </Row>
    )
  }

  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: '60px',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
    },
    {
      title: 'ชื่อ Agent',
      dataIndex: 'name',
      key: 'name',
      render: renderAgentName,
    },
    {
      title: 'เบอร์โทรศัพท์',
      dataIndex: 'mobile',
      key: 'mobile',
      width: '120px',
    },
    {
      title: 'อีเมล',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'ประเภท',
      dataIndex: 'agent_type',
      key: 'agent_type',
      render: (val: string) => formatAgentype(val),
    },
    {
      title: 'วันที่สมัคร',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (val: string) => formatDateTime(val),
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      key: 'status',
      width: '100px',
      render: renderStatus,
    },
    {
      title: '',
      dataIndex: 'submit',
      key: 'submit',
      width: '80px',
      render: renderActionButton,
    },
  ]

  const DetailDrawer = (
    <AgentDetail
      mode={pageMode}
      id={selected?.id || 0}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="start" align="bottom" gutter={[16, 16]}>
        <Col xs={24} md={6}>
          <SearchInput name="keyword" placeholder="ค้นหาชื่อ" value={filter.keyword} onChange={onFilter} />
        </Col>
        <Col xs={24} md={6}>
          <SelectItem
            name={'status'}
            label={''}
            isRequired={true}
            value={filter.status}
            menu={menuAgentStatus}
            placeHolder={'สถานะ'}
            onChange={(val: any): void => onFilter('status', val)}
          />
        </Col>
        <Col>
          <Space size="middle" align="center">
            <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} key="search" />
            {isFilter(filter) && (
              <LinkText color={Theme.colors.primary} onClick={onResetFilter}>
                ล้างการค้นหา
              </LinkText>
            )}
          </Space>
        </Col>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  return (
    <>
      <HomePageLayout selected="agents" title="จัดการข้อมูล Agent" label="">
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={null}
        />
        {PaginationContent}
        {/* {LoadingModal} */}
        {DetailDrawer}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    dataList: selectList(state),
    listEvent: selectListEvent(state),
    loginData: selectLoginData(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(Agents)

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const Link = styled(LinkText)`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  //text-decoration: none;
`
